"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatefulTooltip = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _index = require("../../styles/index.js");
var _index2 = require("../TooltipTrigger/index.js");
var _index3 = require("./index.js");
var _excluded = ["colorSet", "placement", "className", "id", "trigger", "label", "description", "aria-label", "withPortal"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var StatefulTooltip = exports.StatefulTooltip = /*#__PURE__*/_react["default"].forwardRef(function StatefulTooltip(_ref, ref) {
  var colorSet = _ref.colorSet,
    placement = _ref.placement,
    className = _ref.className,
    id = _ref.id,
    trigger = _ref.trigger,
    label = _ref.label,
    description = _ref.description,
    ariaLabel = _ref['aria-label'],
    withPortal = _ref.withPortal,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    showTooltip = _useState2[0],
    setShowTooltip = _useState2[1];
  var triggerWithAttrs = {};
  if (label) {
    triggerWithAttrs['aria-labelledby'] = id;
  }
  if (description) {
    triggerWithAttrs['aria-label'] = ariaLabel;
    triggerWithAttrs['aria-describedby'] = id;
  }
  return /*#__PURE__*/_react["default"].createElement(_index2.TooltipTrigger, {
    overlay: /*#__PURE__*/_react["default"].createElement(_index3.TooltipWrapper, Object.assign({
      ref: ref,
      id: id,
      $isVisible: showTooltip,
      "aria-hidden": true
    }, props), label || description),
    onShow: function onShow() {
      return setShowTooltip(true);
    },
    onHide: function onHide() {
      return setShowTooltip(false);
    },
    placement: placement,
    withPortal: withPortal,
    className: (0, _classnames["default"])((0, _index.textClass)('bodySmall'), (0, _index.addColorSet)(colorSet, className))
  }, trigger(triggerWithAttrs));
});